export enum ConfigLoadingStatus {
    loading_not_yet_started = 'loading_not_yet_started',
    loading = 'loading',
    loaded = 'loaded',
    error = 'error',
}

export enum ExchangeType {
    order_book = 'order_book',
    order_book_v2 = 'order_book_v2',
    cctp = 'cctp_token_messenger',
    wrap_only = 'wrap_only',
    unwrap_only = 'unwrap_only',
}

export enum ResultCode {
    success = 'Success',
    failure = 'Failure',
    pending = 'Pending',
}

export enum StepNames {
    UNSTARTED = 'UNSTARTED',
    SWITCH_NETWORKS = 'SWITCH_NETWORKS',
    APPROVE_TOKENS = 'APPROVE_TOKENS',
    APPROVE_TOKENS_PENDING = 'APPROVE_TOKENS_PENDING',
    DEPOSIT_WETH = 'DEPOSIT_WETH',
    DEPOSIT_WETH_PENDING = 'DEPOSIT_WETH_PENDING',
    UNWRAP_WETH = 'UNWRAP_WETH',
    UNWRAP_WETH_PENDING = 'UNWRAP_WETH_PENDING',
    CONFIRM_SWAP = 'CONFIRM_SWAP',
    CONFIRM_SWAP_PENDING = 'CONFIRM_SWAP_PENDING',
    MATCHING = 'MATCHING',
    MATCH_CREATED = 'MATCH_CREATED',
    MATCH_EXECUTED = 'MATCH_EXECUTED',
    MATCH_TIMED_OUT = 'MATCH_TIMED_OUT',
}

export enum LiquiditySource {
    marketMaker = 'market_maker',
    cctpDirect = 'cctp_direct',
    unavailable = 'unavailable',
}
